let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4vjX8")).then(() => parcelRequire('j3ZnO'));